module.exports = __webpack_public_path__ + "static/media/locked-icon.3f019371.svg";